import { createApi } from '@reduxjs/toolkit/query/react'
import type { SearchSummary } from '@tunasong/models'
import type { SearchRequest, SearchResult } from '@tunasong/schemas'
import baseQuery from './base-query.js'

// Define a service using a base URL and expected endpoints
const apiName = 'search-api'

// Search uses POST with the query in the body rather than the cachedQuerySpec helper.
// kNN queries (useSimilarSearch) carry a 1536-dim embedding vector; URL-encoded plus
// the args header those payloads are ~30 KB, well past CloudFront's URL/header limits
// (TUNASONG-SB / 494 from CloudFront on the kNN response). Search results don't need
// SW push-sync (no providesTags), so dropping the args header is safe.
export const searchApi = createApi({
  reducerPath: apiName,
  keepUnusedDataFor: 60,
  baseQuery,
  endpoints: builder => ({
    search: builder.query<SearchResult<SearchSummary>, { query: SearchRequest; queryType: string }>({
      query: ({ query, queryType }) => ({
        url: `search/?queryType=${queryType}`,
        method: 'POST',
        body: query,
      }),
    }),
  }),
})
